import type { ReactNode } from 'react'
import { PageHead } from './PageHead'

interface Props {
  title: string
  sub?: string
  onBack?: () => void
  right?: ReactNode
}

/**
 * Thanh tiêu đề của các màn hình một cột.
 *
 * Chỉ là một lớp áo mỏng cho {@link PageHead}, giữ lại vì mười mấy màn hình đang gọi tên
 * này. Ở bộ Modern thì nội dung nhảy lên thanh trên; ở bộ Classic nó vẫn là thanh tiêu đề
 * nằm trong trang như xưa nay.
 */
export function AppBar({ title, sub, onBack, right }: Props) {
  return <PageHead title={title} sub={sub} onBack={onBack} right={right} />
}
